module.exports = __webpack_public_path__ + "static/media/ally-logo-pwa@3x.f0178059.jpg";